/* eslint-disable */
import React, { useEffect, useState } from 'react';
import styles from './efforts.module.scss';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import ScopeFE from './ScopeFE/scopeFE';
import Summary from './Summary/summary';
import OtherEfforts from './OtherEfforts/otherEfforts';
import Skillset from './Skillset/skillset';
import BackButton from '../../../../Assets/images/svg/black_back_button.svg';
import { useNavigate, useLocation } from 'react-router-dom';

const Efforts = () => { //NOSONAR
  const [isMobileView, setIsMobileView] = useState(false);
  const [effortValue, setEffortValue] = useState('Scope FE');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    checkMobileView();
    window.scrollTo(0, 0);
        // Set selectedtab from state if available for approval view
        if (location.state?.selectedEffortsTab) {
          setEffortValue(location.state.selectedEffortsTab);
        }
  }, []);

  const handleChange = (event, newValue) => {
    setEffortValue(newValue);
  };

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 1100);
  };

  const effortsDisplay = () => {
    switch (effortValue) {
      case 'Scope FE':
        return <ScopeFE effort="FE"/>;
      case 'Scope BE':
        return <ScopeFE effort="BE"/>;
      case 'Other Tasks':
        return <OtherEfforts />;
      case 'Summary':
        return <Summary />;
      case 'Skillset':
        return <Skillset />;
      default:
        return <ScopeFE />;
    }
  };

  return (
    <div className={styles['scopeDetails-container']}>
      <div className={styles['scopeDetails-mainText']}>
        <button
            type="button"
            className={styles['efforts-back-button']}
            onClick={() => navigate(-1)}
          >
            <img src={BackButton} alt="back icon" />
        </button> Scope
      </div>
      <Box className={styles['efforts-tabs']}>
        <Tabs
          value={effortValue}
          textColor={'#6B5CE8'}
          indicatorColor={'#6B5CE8'}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: '#6B5CE8',  // Custom indicator color
            },
            '& .Mui-selected': {
              color: '#6B5CE8 !important',  // Custom text color for selected tab
            },
          }}
          aria-label="wrapped label tabs example"
        >
          <Tab className={styles['tab']} value="Scope FE" label="Scope FE" sx={{ minWidth: !isMobileView ? 200 : 'auto', textTransform: 'none', fontSize: !isMobileView ? 16 : 14, fontWeight: effortValue === 'Scope FE' ? '600' : '400' }} />
          <Tab className={styles['tab']} value="Scope BE" label="Scope BE" sx={{ minWidth: !isMobileView ? 200 : 'auto', textTransform: 'none', fontSize: !isMobileView ? 16 : 14, fontWeight: effortValue === 'Scope BE' ? '600' : '400' }} />
          <Tab className={styles['tab']} value="Other Tasks" label="Other Tasks" sx={{ minWidth: !isMobileView ? 200 : 'auto', textTransform: 'none', fontSize: !isMobileView ? 16 : 14, fontWeight: effortValue === 'Other Tasks' ? '600' : '400' }} />
          <Tab className={styles['tab']} value="Summary" label="Summary" sx={{ minWidth: !isMobileView ? 200 : 'auto', textTransform: 'none', fontSize: !isMobileView ? 16 : 14, fontWeight: effortValue === 'Summary' ? '600' : '400' }} />
          <Tab className={styles['tab']} value="Skillset" label="Skillset" sx={{ minWidth: !isMobileView ? 200 : 'auto', textTransform: 'none', fontSize: !isMobileView ? 16 : 14, fontWeight: effortValue === 'Skillset' ? '600' : '400' }} />
        </Tabs>
      </Box>
      {effortsDisplay()}
    </div>
  );
};

export default Efforts;
